import { render } from "./albumIntro.vue?vue&type=template&id=132e0438&scoped=true"
import script from "./albumIntro.vue?vue&type=script&lang=js"
export * from "./albumIntro.vue?vue&type=script&lang=js"

import "./albumIntro.vue?vue&type=style&index=0&id=132e0438&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132e0438"]])

export default __exports__